"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savedChildren = exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var savedChildren = {};
exports.savedChildren = savedChildren;
function createChildWapp(_x) {
  return _createChildWapp.apply(this, arguments);
}
function _createChildWapp() {
  _createChildWapp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(_ref) {
    var ID, wapp, parentReq, _ref$req, req, _ref$res, res, artworkResponse, app, _tagsHandle;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ID = _ref.ID, wapp = _ref.wapp, parentReq = _ref.parentReq, _ref$req = _ref.req, req = _ref$req === void 0 ? {} : _ref$req, _ref$res = _ref.res, res = _ref$res === void 0 ? {} : _ref$res;
          artworkResponse = {};
          app = wapp.getTargetObject().app;
          if (wapp.target !== "node") {
            _tagsHandle = wapp.client.middlewares.tags.handle;
            wapp.client.middlewares.tags.handle = function (req, res, next) {
              return next();
            };
          }
          _context.next = 6;
          return app((0, _objectSpread2["default"])({
            url: "/",
            path: "/",
            headers: parentReq.headers,
            timestamp: parentReq.timestamp,
            method: parentReq.method,
            httpVersion: parentReq.httpVersion,
            hostname: parentReq.hostname,
            authority: parentReq.authority,
            protocol: parentReq.protocol,
            secure: parentReq.secure,
            remoteAddress: parentReq.remoteAddress,
            userAgent: parentReq.userAgent
          }, req), (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, res), {}, {
            wapplrReactEndType: "component",
            end: function end(e) {
              artworkResponse = (0, _objectSpread2["default"])({}, e);
              if (res.end) {
                return res.end(e);
              }
            }
          }));
        case 6:
          if (wapp.target !== "node") {
            wapp.client.middlewares.tags.handle = _tagsHandle;
          }
          if (!savedChildren[ID]) {
            savedChildren[ID] = {};
          }
          savedChildren[ID].wapp = artworkResponse.wapp;
          savedChildren[ID].Render = artworkResponse.Render || savedChildren[ID].Render;
          return _context.abrupt("return", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, savedChildren[ID]), artworkResponse));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createChildWapp.apply(this, arguments);
}
var _default = createChildWapp;
exports["default"] = _default;